import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { ModelVehicleModel } from '@app/src/views/StepOne/form/models/modelVehicle';
import { isClientEnv } from '@app/src/utils/validations';

export const modelVehicleService = {
  async get(vehicleId:number, brandId:number, modelName?: string): Promise<ModelVehicleModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      let uri = process.env.API_VEHICLE_MODEL
        .replace(':vehicleId', '' + vehicleId)
        .replace(':brandId', '' + brandId);
      if (modelName) {
        uri = process.env.API_VEHICLE_MODEL_SEARCH
          .replace(':vehicleId', '' + vehicleId)
          .replace(':brandId', '' + brandId)
          .replace(':modelName', '' + modelName);
      }
      const { data } = await axiosAjax.get(uri, config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
